import React from 'react'
import { connect } from 'react-redux'
import { loadProject } from '../../actions'
import { fetchData } from '../../decorators'
import get from 'lodash/get'
import JSONTree from 'react-json-tree'
import './Projects.css'

class Project extends React.Component {
  render() {
    const { project } = this.props

    if(!project) {
      return <div>Loading project</div>
    }

    return (
      <div className="container ">
        <h2>Model ID: {project.modelId}</h2>

        <div className="project-settings-tree-wrapper">
          <JSONTree data={project.settings} />
        </div>
      </div>
    )
  }
}

const withFetch = fetchData((props, nextProps) => {
  const { modelId, project, loadProject } = nextProps
  if(!project) {
    loadProject(modelId)
  }
})(Project)

export default connect(
    (state, ownProps) => ({
        project: get(
            state,
            `entities.projects.${ownProps.params.modelId}`
        ),
        modelId: ownProps.params.modelId
    }),
    {loadProject}
)(withFetch)


// WEBPACK FOOTER //
// ./src/components/Projects/Project.js